import { jsx as r } from "react/jsx-runtime";
import { useCarouselContext as d } from "../../context.js";
import { NextButtonWrapper as s } from "../../style.js";
import { Icon as u } from "../../../Icon/index.js";
import { ChevronRight as c } from "@pelando/fontawesome/icons";
import { useCallback as f } from "react";
function B({
  className: n,
  children: i,
  onClick: t,
  ...m
}) {
  const { scrollForward: o, showNextButton: e } = d(), a = f(
    (p) => {
      t == null || t(p), o();
    },
    [t, o]
  );
  return /* @__PURE__ */ r(s, { className: n, "aria-hidden": !e, children: /* @__PURE__ */ r(
    "button",
    {
      type: "button",
      onClick: a,
      disabled: !e,
      ...m,
      children: i || /* @__PURE__ */ r(u, { icon: c })
    }
  ) });
}
export {
  B as NextIndicator
};
